//https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
export var rgbToHex = function rgbToHex(r, g, b) {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
export var hexToRgb = function hexToRgb(hex) {
  var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var alpha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var noAlpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var test = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  var result = test ? {
    r: parseInt(test[1], 16),
    g: parseInt(test[2], 16),
    b: parseInt(test[3], 16)
  } : null;
  if (!result) return null;
  if (noAlpha) return "rgb(".concat(result.r, ", ").concat(result.g, ", ").concat(result.b, ")");
  return parser ? "rgba(".concat(result.r, ", ").concat(result.g, ", ").concat(result.b, ", ").concat(alpha, ")") : result;
};
export var lighten = function lighten(col, amt) {
  if (col[0] === "#") col = col.slice(1);
  var num = parseInt(col, 16);
  var r = (num >> 16) + amt;
  if (r > 255) r = 255;
  if (r < 0) r = 0;
  var b = (num >> 8 & 0x00FF) + amt;
  if (b > 255) b = 255;
  if (b < 0) b = 0;
  var g = (num & 0x0000FF) + amt;
  if (g > 255) g = 255;
  if (g < 0) g = 0;
  return '#' + (g | b << 8 | r << 16).toString(16);
};
var id = 0;
export var randomId = function randomId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';
  return "".concat(prefix, "-").concat(++id);
};